// extracted by mini-css-extract-plugin
export var background = "Artwork-module--background--2p8if";